import { render, staticRenderFns } from "./OrderBuyP.vue?vue&type=template&id=3738ed78&"
import script from "./OrderBuyP.vue?vue&type=script&lang=js&"
export * from "./OrderBuyP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports